import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  viewTranscript: {
    id: 'components.CardLumaBotFlow.components.KebabActionsMenu.viewTranscript',
    defaultMessage: 'View as transcript',
  },
  viewChat: {
    id: 'components.CardLumaBotFlow.components.KebabActionsMenu.viewChat',
    defaultMessage: 'View as chat',
  },
  delete: {
    id: 'components.CardLumaBotFlow.components.KebabActionsMenu.delete',
    defaultMessage: 'Delete',
  },
});
